// Step continue
// Determines which step the user is on and shows the next step
// in the form flow if user is allowed to continue.
// ----------------------------------------------------------------

import $ from 'jquery';
import { focusFirstFieldsetInput } from '../focus-first-fieldset-input';
import { formProgressTracker } from './form-progress-tracker';

export function stepContinue(fieldset, stepValid) {

    if (stepValid === true) {

        // Hides current fieldset.
        fieldset.hide();

        // Gets the current step value and sets next step value.
        var step = parseInt(fieldset.attr('data-donation-form-step'));
        var nextStep = step + 1;

        // Sets current step mobile and desktop buttons to valid styling.
        $(fieldset).closest('.js-donationForm').find('button[data-donation-form-step="' + step + '"]').find('.c-icon').removeClass('u-invisible');

        // Removes the (next step) button disabled prop from mobile accordion and desktop sidebar.
        // Removes/adds classes as needend between donation form and donation form v2.
        $(fieldset).closest('.js-donationForm').find('button[data-donation-form-step="' + nextStep + '"]').prop('disabled', false);
        $(fieldset).closest('.js-donationForm').find('button[data-donation-form-step="' + nextStep + '"]').removeClass('u-color-grey-dark');
        $(fieldset).closest('.js-donationForm').find('button[data-donation-form-step="' + nextStep + '"]').removeClass('u-bg-grey-lighter');
        $(fieldset).closest('.js-donationForm').find('button[data-donation-form-step="' + nextStep + '"]').removeClass('u-bg-grey-light');
        $(fieldset).closest('.js-donationForm').find('button[data-donation-form-step="' + nextStep + '"]').addClass('u-bg-yellow u-color-grey-darkest');

        // Shows the fieldset of the next step.
        $(fieldset).closest('.js-donationForm').find('fieldset[data-donation-form-step="' + nextStep + '"]').show();

        // Update form progress tracker
        formProgressTracker(fieldset, nextStep);

        // Focus first input of next step.
        focusFirstFieldsetInput(nextStep);


        // TODO: Refactor following for step-continue and step-back
        // Animate scrolling to next element if viewport is "md" breakpoint or lower
        // or if mobile persistence is forced.
        if (
            $(window).width() < 1024 ||
            $(fieldset).closest('.js-donationForm').hasClass('js-donationFormPersistMobile')
        ) {
            // Some forms may have the step buttons hidden in favour of only forward/backward buttons.
            // If so then scroll to the first visible fieldset within the form.
            if ($('.js-formStepTrigger').is(':visible')) {

                // donation-form-v2 may not have button available
                if ($(fieldset).next().is('button')) {
                    $('html, body').animate({
                        scrollTop: $(fieldset).next('button').offset().top
                    });

                } else if ($(fieldset).next().is('fieldset')) {
                    $('html, body').animate({
                        scrollTop: $(fieldset).closest('.js-donationForm').offset().top
                    });

                }

            } else {
                $('html, body').animate({
                    scrollTop: $(fieldset).closest('.js-donationForm').find('fieldset:visible').offset().top
                });

            }
        }

    }

}
